import React, { useState, useEffect, useCallback } from 'react'
import { CalendarClock, RefreshCw, Check, Ban } from 'lucide-react'
import { toast } from 'sonner'

const API = process.env.REACT_APP_BACKEND_URL
const URG = { depassee: 'bg-red-100 text-red-700 border-red-200', critique: 'bg-orange-100 text-orange-700 border-orange-200', proche: 'bg-amber-50 text-amber-700 border-amber-200', normale: 'bg-slate-50 text-slate-600 border-slate-200', aucune: 'bg-emerald-50 text-emerald-700 border-emerald-200' }
const STATUT = { a_venir: 'A venir', respectee: 'Respectee', depassee: 'Depassee', non_applicable: 'Non applicable' }
const fmtDate = (d) => d ? new Date(d).toLocaleDateString('fr-FR') : '--'

/** Lot 2 : echeances reglementaires (reserves J+N, prescription) avec compte a rebours. */
export default function TransportEcheancesBlock({ sinistreId, refreshKey }) {
  const [rows, setRows] = useState([])
  const load = useCallback(async () => {
    const r = await fetch(`${API}/api/sinistres/${sinistreId}/echeances`)
    if (r.ok) setRows((await r.json()).echeances || [])
  }, [sinistreId])
  useEffect(() => { load() }, [load, refreshKey])

  async function generer(remplacer) {
    const r = await fetch(`${API}/api/sinistres/${sinistreId}/echeances/generer?remplacer=${remplacer}`, { method: 'POST' })
    const d = await r.json()
    if (r.ok) { toast.success(`${d.echeances.length} echeance(s) generee(s)`); load() } else toast.error(d.detail || 'Erreur')
  }
  async function setStatut(id, statut) {
    const r = await fetch(`${API}/api/sinistres/${sinistreId}/echeances/${id}`, { method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ statut }) })
    if (r.ok) { toast.success('Echeance mise a jour'); load() } else toast.error('Erreur')
  }

  return (
    <div className="bg-white rounded-xl border border-slate-200 shadow-sm overflow-hidden" data-testid="transport-echeances-block">
      <div className="px-5 py-3 border-b border-slate-100 bg-slate-50 flex items-center justify-between">
        <h2 className="font-semibold text-slate-800 text-sm flex items-center gap-2"><CalendarClock size={14} className="text-red-600" /> Echeances reglementaires</h2>
        <button onClick={() => generer(rows.length > 0)} className="text-xs px-3 py-1.5 rounded-lg border border-slate-300 text-slate-700 hover:bg-slate-100 flex items-center gap-1" data-testid="btn-generer-echeances"><RefreshCw size={12} /> {rows.length ? 'Regenerer (convention / date de livraison)' : 'Generer'}</button>
      </div>
      <div className="p-5 space-y-2">
        {rows.length === 0 && <p className="text-xs text-slate-400">Aucune echeance. Renseignez la date de livraison (ou du fait) et la convention, puis generez.</p>}
        {rows.map(e => (
          <div key={e.id} className={`flex items-center justify-between border rounded-lg px-3 py-2 text-xs ${URG[e.statut === 'a_venir' ? e.urgence : e.statut_calcule === 'depassee' ? 'depassee' : 'aucune']}`} data-testid={`echeance-${e.type}`}>
            <div>
              <p className="font-medium">{e.libelle}</p>
              <p className="text-[11px] opacity-80">Echeance {fmtDate(e.date_echeance)} · base {fmtDate(e.date_base)} · {STATUT[e.statut_calcule]}{e.date_realisation ? ` le ${fmtDate(e.date_realisation)}` : ''}</p>
              {e.regle && <p className="text-[10px] opacity-60">{e.regle}</p>}
            </div>
            <div className="flex items-center gap-2">
              {e.statut === 'a_venir' && <span className="font-bold whitespace-nowrap" data-testid={`countdown-${e.type}`}>{e.jours_restants < 0 ? `J+${-e.jours_restants} depasse` : e.jours_restants === 0 ? "Aujourd'hui" : `J-${e.jours_restants}`}</span>}
              {e.statut === 'a_venir' && <>
                <button onClick={() => setStatut(e.id, 'respectee')} title="Marquer respectee" className="p-1 hover:bg-white/60 rounded" data-testid={`btn-respectee-${e.type}`}><Check size={13} /></button>
                <button onClick={() => setStatut(e.id, 'non_applicable')} title="Non applicable" className="p-1 hover:bg-white/60 rounded"><Ban size={13} /></button>
              </>}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
